var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFundReportDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 268,
    height: 339,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h63v4H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 268,
    height: 349,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1370",
    transform: "translate(2613 -2249)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 53",
    transform: "translate(-2895 1013)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(282 1236)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 8",
    fill: "#f2f3f4",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 14h228a8 8 0 0 1 8 8v317H12V22a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14.5h228a7.5 7.5 0 0 1 7.5 7.5v316.5h-243V22a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 9",
    fill: "#f7f7f7",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302 1250h228a8 8 0 0 1 8 8v16H294v-16a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 1250.5h228a7.5 7.5 0 0 1 7.5 7.5v15.5h-243V1258a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(304 1259)",
    fill: "#ff5552"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 6",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(312 1259)",
    fill: "#ffb53d"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 7",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(320 1259)",
    fill: "#00c243"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 10",
    fill: "#fff",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294 1273h244v20H294z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M294.5 1273.5h243v19h-243z"
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 8",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(304 1278)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(464 1281)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(480 1281)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(496 1281)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(512 1281)",
    fill: "#9098a4"
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 25",
    width: 209,
    height: 57,
    rx: 1,
    transform: "translate(-2583 2306)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": "Fund Name Lorem Ipsum",
    transform: "translate(-2571 2322)",
    fill: "#454545",
    fontSize: 10,
    fontFamily: "Arial-BoldMT, Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Fund Name Lorem Ipsum")), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 27",
    width: 43,
    height: 4,
    rx: 1,
    transform: "translate(-2571 2327)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 29",
    width: 187,
    height: 4,
    rx: 1,
    transform: "translate(-2571 2344)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 30",
    width: 120,
    height: 4,
    rx: 1,
    transform: "translate(-2571 2351)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 28",
    width: 33,
    height: 4,
    rx: 1,
    transform: "translate(-2522 2327)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 31",
    width: 27,
    height: 4,
    rx: 1,
    transform: "translate(-2571 2337)",
    fill: "#9098a4",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1366",
    transform: "translate(-3423 1003)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1215"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1500",
    fill: "#eaeaea",
    d: "M840 1472h209v16H840z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 11",
    transform: "translate(976 1478)",
    opacity: 0.5,
    clipPath: "url(#b)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(16)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(32)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(48)"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1216"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1504",
    fill: "#fff",
    d: "M840 1489h209v66H840z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 145",
    d: "m849.487 1545.723 30.816-31.406 40.985 10.467 22.432-14.153 25.334 10.309 27.761-10.309 15.815 3.686 18.574-10.35h7.829",
    fill: "none",
    stroke: "#fd0826",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 146",
    d: "m1039.033 1516.647-27.575-7.288-26.86 19.564-40.514 6.232-50.769-25.8-25.541 25.8-17.444 10.786",
    fill: "none",
    stroke: "#ffc1c8",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1598",
    width: 49,
    height: 6,
    rx: 1,
    transform: "translate(856 1477)",
    fill: "#9098a4",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1369"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 26",
    width: 209,
    height: 84,
    rx: 1,
    transform: "translate(-2583 2384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ring Chart1",
    fill: "#fd0826"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 136",
    d: "M-2431.271 2396.727a26.271 26.271 0 0 1 22.751 13.135 26.271 26.271 0 0 1 0 26.271l-4.583-2.646a20.979 20.979 0 0 0 0-20.979 20.979 20.979 0 0 0-18.168-10.489Z",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 137",
    d: "M-2408.519 2436.137a26.271 26.271 0 0 1-34.15 10.53l2.3-4.768a20.979 20.979 0 0 0 27.267-8.412Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 138",
    d: "M-2442.669 2446.667a26.271 26.271 0 0 1-13.056-33.267l4.926 1.933a20.979 20.979 0 0 0 10.426 26.566Z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 139",
    d: "M-2455.73 2413.4a26.271 26.271 0 0 1 24.459-16.673v5.292a20.979 20.979 0 0 0-19.529 13.314Z",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 55",
    transform: "translate(-3425 1016)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 33",
    width: 77,
    height: 4,
    rx: 1,
    transform: "translate(858 1391)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 34",
    width: 77,
    height: 4,
    rx: 1,
    transform: "translate(858 1398)",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 56",
    transform: "translate(-3425 1030)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 33",
    width: 77,
    height: 4,
    rx: 1,
    transform: "translate(858 1391)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 34",
    width: 77,
    height: 4,
    rx: 1,
    transform: "translate(858 1398)",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57",
    transform: "translate(-3425 1044)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 33",
    width: 77,
    height: 4,
    rx: 1,
    transform: "translate(858 1391)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 34",
    width: 77,
    height: 4,
    rx: 1,
    transform: "translate(858 1398)",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 32",
    width: 27,
    height: 4,
    rx: 1,
    transform: "translate(-2567 2397)",
    fill: "#9098a4",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1368",
    transform: "translate(0 -90)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1595",
    width: 66,
    height: 8,
    rx: 1,
    transform: "translate(-2583 2461)",
    fill: "#9098a4",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1367",
    transform: "translate(0 58.365)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 176",
    d: "M-2417 2404.635h8a2 2 0 0 1 0 4h-8a2 2 0 0 1 0-4Z",
    fill: "#fd0826"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1596",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(-2403 2405)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1597",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(-2387 2405)",
    fill: "#9098a4"
  })))), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1601",
    width: 107,
    height: 8,
    rx: 1,
    transform: "translate(-2583 2569)",
    fill: "#9098a4",
    opacity: 0.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundReportDesktop);
export default __webpack_public_path__ + "static/media/fund-report-desktop.e74d22b23a06b09b13ab4f9836843d9a.svg";
export { ForwardRef as ReactComponent };